import { Itinerary } from '../../../../resources/itinerary/domain/types/Itinerary';
import { PickDomain } from '../../../../shared/utilities/types/PickDomain';

const MAX_ACTIVITY_TYPES = 4;
const MAX_ACTIVITY_TYPES_WITH_FILTERS = 6;

type UseItineraryActivityTypesProps = {
    itinerary: PickDomain<
        Itinerary,
        | 'id'
        | 'startingPrice'
        | 'duration'
        | 'isGIR'
        | 'title'
        | 'rangeName'
        | 'slug'
        | 'picture'
        | 'activityTypes',
        {
            agency?: Pick<
                Itinerary['agency'],
                'id' | 'picture' | 'name' | 'nameTranslationRule' | 'isLocalHero'
            >;
            pointsOfInterest?: Array<Pick<Itinerary['pointsOfInterest'][number], 'name'>>;
        }
    > & {
        typeOfProfile: Itinerary['typeOfProfile'] | null;
    };
    selectedFilters: Array<{ translation: string }>;
};

export const useItineraryActivityTypes = ({
    itinerary,
    selectedFilters,
}: UseItineraryActivityTypesProps) => {
    const activityTypes = new Set<string>();

    const maxSize = activityTypes.size > 0 ? MAX_ACTIVITY_TYPES_WITH_FILTERS : MAX_ACTIVITY_TYPES;
    const remainingSlots = maxSize - activityTypes.size;

    selectedFilters
        .slice(0, remainingSlots)
        .forEach(({ translation }) => activityTypes.add(translation));

    if (activityTypes.size < maxSize) {
        itinerary.activityTypes
            .slice(0, remainingSlots)
            .forEach((activity) => activityTypes.add(activity));
    }

    return Array.from(activityTypes);
};
